import { memoize, range } from 'lodash-es';

/**
 *
 * @param start
 * @param end
 */
export let _getDuration = (start: string, end: string): number => {
  const splitStart = start.split(':');
  const startHour = +splitStart[0];
  const startMinute = +splitStart[1];

  const splitEnd = end.split(':');
  const endHour = +splitEnd[0];
  const endMinute = +splitEnd[1];

  let hours = endHour - startHour;
  let minutes = endMinute - startMinute;

  minutes = startMinute !== 0 ? minutes + 60 : minutes;
  hours = startMinute !== 0 ? hours - 1 : hours;

  return hours * 60 + minutes;
};
export let getDuration = memoize(_getDuration, (...args) => JSON.stringify(args));

/**
 *
 * @param time
 */
export let _getMinutes = (time: string): number => {
  const splitTime = time.split(':');
  const hour = +splitTime[0];
  const minute = +splitTime[1];

  return hour * 60 + minute;
};
export let getMinutes = memoize(_getMinutes);

/**
 *
 * @param minutes
 */
export let _convertMinutesToTime = (minutes: number): string => {
  let h: any = Math.floor(minutes / 60);
  let m: any = minutes % 60;

  h = h < 10 ? `0${h}` : h;
  m = m < 10 ? `0${m}` : m;

  return `${h}:${m}`;
};
export let convertMinutesToTime = memoize(_convertMinutesToTime);

/**
 *
 * @param from
 * @param to
 * @param edge
 * @param resolution
 */
export let _getTimes = (
  from: string,
  to: string,
  edge: string,
  resolution = 10
): string[] => {
  const times: string[] = [];

  if (!from || !to) {
    range(0, 1440 + resolution, resolution).forEach((m) => {
      times.push(convertMinutesToTime(m));
    });
  } else {
    let min = getMinutes(from);
    let max = getMinutes(to);

    if (min >= max) {
      return times;
    }

    min = min ? min + resolution : min;
    max = max === 1440 ? max + resolution : max;

    min = edge === '00:00' ? min + resolution : min;
    max = edge === '24:00' ? max - resolution : max;

    range(min, max, resolution).forEach((m) => {
      times.push(convertMinutesToTime(m));
    });
  }

  return times;
};
export let getTimes = memoize(_getTimes, (...args) => JSON.stringify(args));
